<template>
    <b-container>
        <b-row align-h="center">
            <b-col cols="12" v-if="user.role === 'Cashier' && user.branch">
                <b-card :title="title" :sub-title="subtitle" class="text-center bg-none my-4" body-class="px-0">
                    <b-form>
                        <b-row align-h="center">
                            <b-col cols="12" align-self="center">
                                <img :src="'https://flagcdn.com/h40/' + (user.country ? user.country : '').toLowerCase() + '.png'"
                                    :srcset="'https://flagcdn.com/h80/' + (user.country ? user.country : '').toLowerCase() + '.png 2x'"
                                    height="28" :alt="user.country" class="border-flag">
                                <i class="material-icons mx-2 v-align">send</i>
                                <img :src="'https://flagcdn.com/h40/' + (form.country ? form.country : '').toLowerCase() + '.png'"
                                    :srcset="'https://flagcdn.com/h80/' + (form.country ? form.country : '').toLowerCase() + '.png 2x'"
                                    height="28" :alt="form.country" class="border-flag">
                            </b-col>
                        </b-row>
                        <b-progress max="100" height="2rem" class="my-4" show-progress animated variant="primary">
                            <b-progress-bar :value="progress">
                                <span><b style="font-size: 1rem;">{{ progress.toFixed(0) }} %</b></span>
                            </b-progress-bar>
                        </b-progress>
                        <b-row align-h="center" v-if="current_step === 1">
                            <b-col cols="12" md="10" align-self="start">
                                <b-button variant="outline-primary" class="btn-r5 shadow" :disabled="loading"
                                    @click="clearData('sender')">
                                    <i class="material-icons">add</i>
                                    <span>Agregar<br>Nuevo</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" :disabled="loading"
                                    v-b-modal.sender>
                                    <i class="material-icons">group</i>
                                    <span>Seleccione<br>Cliente</span>
                                </b-button>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name + ':'">
                                    <b-form-input name="sender_name" v-model="form.sender.name" type="text"
                                        class="text-center" v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('sender_name')" :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading" aria-describedby="sender_name-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_name-live-feedback">{{
                                        veeErrors.first('sender_name') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.lname + ':'">
                                    <b-form-input name="sender_lname" v-model="form.sender.lname" type="text"
                                        class="text-center" v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('sender_lname')"
                                        :data-vv-as="(labels.lname).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_lname-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_lname-live-feedback">{{
                                        veeErrors.first('sender_lname') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mname + ':'">
                                    <b-form-input name="sender_mname" v-model="form.sender.mname" type="text"
                                        class="text-center" v-validate="'alpha_spaces|max:19'"
                                        :state="validateState('sender_mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_mname-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_mname-live-feedback">{{
                                        veeErrors.first('sender_mname') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.email + ':'">
                                    <b-form-input name="sender_email" v-model="form.sender.email" type="text"
                                        inputmode="email" class="text-center" v-validate="'required:true|email'"
                                        :state="validateState('sender_email')"
                                        :data-vv-as="(labels.email).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_email-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_email-live-feedback">{{
                                        veeErrors.first('sender_email') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mobile + ':'">
                                    <b-form-input name="sender_mobile" v-model="form.sender.mobile" type="text"
                                        inputmode="numeric" class="text-center" v-validate="'required:true|numeric'"
                                        :state="validateState('sender_mobile')"
                                        :data-vv-as="(labels.mobile).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_mobile-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_mobile-live-feedback">{{
                                        veeErrors.first('sender_mobile') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.birthday + ':'">
                                    <b-form-datepicker name="sender_birthday" v-model="form.sender.birthday"
                                        v-bind="labels['es'] || {}" v-validate="'required:true|date_format:yyyy-MM-dd'"
                                        :state="validateState('sender_birthday')"
                                        :data-vv-as="(labels.birthday).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_birthday-live-feedback" locale="es" :min="minDate"
                                        :max="maxDate" hide-header no-flip class="text-left"></b-form-datepicker>
                                    <b-form-invalid-feedback id="sender_birthday-live-feedback">{{
                                        veeErrors.first('sender_birthday') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.profession + ':'">
                                    <b-form-select name="sender_profession" :options="professions"
                                        :value="form.sender.profession" v-model="form.sender.profession"
                                        v-validate="'required:true'" :state="validateState('sender_profession')"
                                        :data-vv-as="(labels.profession).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_profession-live-feedback" class="form-control"
                                        value-field="name" text-field="name"></b-form-select>
                                    <b-form-invalid-feedback id="sender_profession-live-feedback">{{
                                        veeErrors.first('sender_profession') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.pep + ':'">
                                    <b-form-select name="sender_pep" :options="yes_no" :value="form.sender.pep"
                                        v-model="form.sender.pep" v-validate="'required:true'"
                                        :state="validateState('sender_pep')" :data-vv-as="(labels.pep).toLowerCase()"
                                        :disabled="loading" aria-describedby="sender_pep-live-feedback"
                                        class="form-control" value-field="code" text-field="text"></b-form-select>
                                    <b-form-invalid-feedback id="sender_pep-live-feedback">{{
                                        veeErrors.first('sender_pep') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <h6 class="subtitle text-center mt-0">Identificación Personal</h6>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.td + ':'">
                                    <b-form-select name="sender_td" :options="sender_td" :value="form.sender.td"
                                        v-model="form.sender.td" class="form-control select-center"
                                        v-validate="'required:true'" :state="validateState('sender_td')"
                                        :data-vv-as="(labels.td).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_td-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="sender_td-live-feedback">{{
                                        veeErrors.first('sender_td') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.sender.td === 'RUT'">
                                <b-form-group :label="labels.rut + ':'">
                                    <b-form-input name="sender_rut" v-model="form.sender.rut" type="text"
                                        class="text-center" v-validate="'required:true'"
                                        :state="validateState('sender_rut')" :data-vv-as="(labels.rut).toLowerCase()"
                                        :disabled="loading" aria-describedby="sender_rut-live-feedback"
                                        v-mask="mask"></b-form-input>
                                    <b-form-invalid-feedback id="sender_rut-live-feedback">{{
                                        veeErrors.first('sender_rut') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-else>
                                <b-form-group :label="labels.nd + ':'">
                                    <b-form-input name="sender_nd" v-model="form.sender.nd" type="text"
                                        :inputmode="form.sender.td === 'PS' ? 'text' : 'numeric'" class="text-center"
                                        v-validate="'required:true' + (form.sender.td === 'PS' ? '' : '|numeric')"
                                        :state="validateState('sender_nd')" :data-vv-as="(labels.nd).toLowerCase()"
                                        :disabled="loading" aria-describedby="sender_nd-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_nd-live-feedback">{{
                                        veeErrors.first('sender_nd') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.issuedBy + ':'">
                                    <b-form-select name="sender_issuedBy" :options="countries_list"
                                        :value="form.sender.issuedBy" v-model="form.sender.issuedBy"
                                        v-validate="'required:true'" :state="validateState('sender_issuedBy')"
                                        :data-vv-as="(labels.issuedBy).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_issuedBy-live-feedback" class="form-control"
                                        value-field="iso2" text-field="name"></b-form-select>
                                    <b-form-invalid-feedback id="sender_issuedBy-live-feedback">{{
                                        veeErrors.first('sender_issuedBy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.expiration + ':'">
                                    <b-form-datepicker name="sender_expiration" v-model="form.sender.expiration"
                                        v-bind="labels['es'] || {}" v-validate="'required:true|date_format:yyyy-MM-dd'"
                                        :state="validateState('sender_expiration')"
                                        :data-vv-as="(labels.expiration).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_expiration-live-feedback" locale="es" :min="minDateExp"
                                        hide-header no-flip class="text-left"></b-form-datepicker>
                                    <b-form-invalid-feedback id="sender_expiration-live-feedback">{{
                                        veeErrors.first('sender_expiration') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <h6 class="subtitle text-center mt-0">Ubicación Actual</h6>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.address + ':'">
                                    <b-form-input name="sender_address" v-model="form.sender.address" type="text"
                                        class="text-center" v-validate="'required:true|min:3|max:70'"
                                        :state="validateState('sender_address')"
                                        :data-vv-as="(labels.address).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_address-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_address-live-feedback">{{
                                        veeErrors.first('sender_address') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.district + ':'">
                                    <b-form-input name="sender_district" v-model="form.sender.district" type="text"
                                        class="text-center" v-validate="'required:true|min:3|max:35'"
                                        :state="validateState('sender_district')"
                                        :data-vv-as="(labels.district).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_district-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_district-live-feedback">{{
                                        veeErrors.first('sender_district') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.zipcode + ':'">
                                    <b-form-input name="sender_zipcode" v-model="form.sender.zipcode" type="text"
                                        class="text-center" v-validate="'required:true|min:4|max:8'"
                                        :state="validateState('sender_zipcode')"
                                        :data-vv-as="(labels.zipcode).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_zipcode-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_zipcode-live-feedback">{{
                                        veeErrors.first('sender_zipcode') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city + ':'">
                                    <b-form-input name="sender_city" v-model="form.sender.city" type="text"
                                        class="text-center" v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('sender_city')" :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading" aria-describedby="sender_city-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_city-live-feedback">{{
                                        veeErrors.first('sender_city') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state + ':'">
                                    <b-form-input name="sender_state" v-model="form.sender.state" type="text"
                                        class="text-center" v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('sender_state')"
                                        :data-vv-as="(labels.state).toLowerCase()" :disabled="loading"
                                        aria-describedby="sender_state-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="sender_state-live-feedback">{{
                                        veeErrors.first('sender_state') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <!-- Modal Search Sender -->
                            <b-modal id="sender" centered no-fade header-class="text-center" header-bg-variant="primary"
                                header-text-variant="light" header-close-variant="light" footer-class="border-0"
                                hide-footer body-class="text-center px-4 my-4" title="Buscar Cliente" tabindex="-1"
                                role="dialog" size="lg" aria-hidden="true">
                                <b-form id="formSender" @submit.stop.prevent="getDataSender('sender')">
                                    <b-row align-h="center">
                                        <b-col cols="12" sm="10" md="9" class="mb-3" align-self="start">
                                            <b-form-group :label="labels.sender + ':'">
                                                <v-select :options="senders" v-model="senderSelected" :searchable="true"
                                                    :disabled="loadingSends"
                                                    labelTitle="-- Por favor seleccione un enviador --"
                                                    labelNotFound="El cliente no existe"
                                                    labelSearchPlaceholder="Buscar Cliente" />
                                                <b-form-select v-show="false" name="sender" :options="senders"
                                                    :value="form.sender.id" v-model="form.sender.id"
                                                    class="form-control select-center"
                                                    v-validate="'required:true|excluded:0'"
                                                    :state="validateState('sender')"
                                                    :data-vv-as="(labels.sender).toLowerCase()" :disabled="loadingSends"
                                                    aria-describedby="sender-live-feedback" value-field="id"
                                                    text-field="text"></b-form-select>
                                                <b-form-invalid-feedback id="sender-live-feedback">{{
                                                    veeErrors.first('sender') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" align-self="center">
                                            <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                                                form="formSender" :disabled="loadingSends">
                                                <b-spinner small type="grow" v-if="loadingSends"></b-spinner>
                                                <b-icon icon="check-all" aria-hidden="true" v-else></b-icon>
                                                &nbsp;&nbsp;<span>{{ loadingSends ? 'Aplicando...' : 'Aplicar' }}</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-modal>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 2">
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Seleccione ' + labels.country + ':'">
                                    <b-form-select name="country" :options="countries" v-validate="'required:true'"
                                        :state="validateState('country')" :data-vv-as="(labels.country).toLowerCase()"
                                        :disabled="loading" aria-describedby="country-live-feedback"
                                        :value="form.country" v-model="form.country" class="form-control select-center"
                                        size="lg"></b-form-select>
                                    <b-form-invalid-feedback id="country-live-feedback">{{ veeErrors.first('country')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Seleccione ' + labels.payReceiver + ':'">
                                    <b-form-radio-group v-model="form.payReceiver" :options="payReceivers"
                                        v-validate="'required:true'" :state="validateState('payReceiver')"
                                        :data-vv-as="(labels.payReceiver).toLowerCase()" :disabled="loading"
                                        aria-describedby="payReceiver-live-feedback" button-variant="outline-primary"
                                        class="btn-block align-baseline" size="lg" name="payReceiver"
                                        buttons></b-form-radio-group>
                                    <b-form-invalid-feedback id="payReceiver-live-feedback"
                                        :state="validateState('payReceiver')">{{ veeErrors.first('payReceiver')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="labels.office + ':'" v-show="form.payReceiver === 'Cash'">
                                    <v-select :options="offices" v-model="officeSelected" :searchable="true"
                                        :disabled="loading" class="pb-1 h-auto"
                                        labelTitle="-- Por favor seleccione una oficina --"
                                        labelNotFound="La oficina no existe" labelSearchPlaceholder="Buscar Oficina"
                                        textProp="name" />
                                    <b-form-select v-show="false" name="office" :options="offices" :value="form.office"
                                        v-model="form.office" class="form-control select-center"
                                        v-validate="(form.payReceiver === 'Cash' ? 'required:true' : '')"
                                        :state="validateState('office')" :data-vv-as="(labels.office).toLowerCase()"
                                        :disabled="loading" aria-describedby="office-live-feedback" value-field="code"
                                        text-field="name">
                                    </b-form-select>
                                    <b-form-invalid-feedback id="office-live-feedback">{{ veeErrors.first('office')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group :label="labels.bank + ':'" v-show="form.payReceiver === 'Bank'">
                                    <v-select :options="banks" v-model="bankSelected" :searchable="true"
                                        :disabled="loading" class="pb-1 h-auto"
                                        labelTitle="-- Por favor seleccione un banco --"
                                        labelNotFound="El banco no existe" labelSearchPlaceholder="Buscar banco"
                                        textProp="name" />
                                    <b-form-select v-show="false" name="bank" :options="banks" :value="form.bank"
                                        v-model="form.bank" text-field="name" value-field="code"
                                        class="form-control select-center"
                                        v-validate="(form.payReceiver === 'Bank' ? 'required:true' : '')"
                                        :state="validateState('bank')" :data-vv-as="(labels.bank).toLowerCase()"
                                        :disabled="loading" aria-describedby="bank-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="bank-live-feedback">{{ veeErrors.first('bank')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group :label="labels.wallet + ':'" v-show="form.payReceiver === 'Wallet'">
                                    <v-select :options="wallets" v-model="walletSelected" :searchable="true"
                                        :disabled="loading" class="pb-1 h-auto"
                                        labelTitle="-- Por favor seleccione una Wallet --"
                                        labelNotFound="La wallet no existe" labelSearchPlaceholder="Buscar Wallet"
                                        textProp="name" />
                                    <b-form-select v-show="false" name="wallet" :options="wallets" :value="form.wallet"
                                        v-model="form.wallet" text-field="name" value-field="code"
                                        class="form-control select-center"
                                        v-validate="(form.payReceiver === 'Wallet' ? 'required:true' : '')"
                                        :state="validateState('wallet')" :data-vv-as="(labels.wallet).toLowerCase()"
                                        :disabled="loading" aria-describedby="bank-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="wallet-live-feedback">{{ veeErrors.first('wallet')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Seleccione ' + labels.type + ':'">
                                    <b-form-radio-group v-model="form.type" :options="types"
                                        v-validate="'required:true'" :state="validateState('type')"
                                        :data-vv-as="(labels.type).toLowerCase()" :disabled="loading"
                                        aria-describedby="type-live-feedback" button-variant="outline-primary"
                                        class="btn-block align-baseline" size="lg" name="type"
                                        buttons></b-form-radio-group>
                                    <b-form-invalid-feedback id="type-live-feedback" :state="validateState('type')">{{
                                        veeErrors.first('type') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Ingrese ' + labels.value + ':'">
                                    <b-input-group>
                                        <template #prepend>
                                            <b-input-group-text class="m-0 px-4 btrr-0 bbrr-0"><b>{{ form.currency ===
                                                'PEN' ? 'S/.' : (form.currency === 'EUR' ? '€' : '$')
                                                    }}</b></b-input-group-text>
                                        </template>
                                        <currency-input v-model="form.value" name="value"
                                            v-validate="'required:true|min_value:' + min + '|max_value:' + max"
                                            :state="validateState('value')" aria-describedby="value-live-feedback"
                                            :data-vv-as="(labels.value).toLowerCase()" :disabled="loading"
                                            :precision="currency_precision"
                                            class="text-right text-sm-center form-control form-control-lg"
                                            style="padding: 0.5rem 1rem; background-image: none;"></currency-input>
                                        <template #append>
                                            <b-dropdown :text="form.currency" variant="default" right
                                                class="m-0 btlr-0 bblr-0" toggle-class="px-sm-4">
                                                <template v-for="item in currencies">
                                                    <b-dropdown-item
                                                        :key="item.code"
                                                        @click="form.currency = item.code"
                                                        v-if="(form.type === 'S' && item.country === form.sender.country) || (form.type === 'R' && item.country === form.country && item.enabled)">
                                                        {{ item.code + ' - ' + item.name }}
                                                    </b-dropdown-item>
                                                </template>
                                            </b-dropdown>
                                        </template>
                                    </b-input-group>
                                    <b-form-invalid-feedback id="value-live-feedback">{{ veeErrors.first('value')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4">
                                <b-form-group :label="'Seleccione ' + labels.convert + ':'" v-show="quotes[0]">
                                    <b-form-radio-group v-model="form.convert" :options="quotes"
                                        v-validate="{ required: true, is_not: 0 }" :state="validateState('convert')"
                                        :data-vv-as="(labels.convert).toLowerCase()" :disabled="loading || quotingTerrapay"
                                        aria-describedby="convert-live-feedback" button-variant="outline-primary"
                                        class="btn-block align-baseline" size="lg" name="convert"
                                        buttons></b-form-radio-group>
                                    <small v-if="quotingTerrapay" class="text-muted">Cotizando...</small>
                                    <b-form-invalid-feedback id="convert-live-feedback"
                                        :state="validateState('convert')">{{
                                            veeErrors.first('convert') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 3">
                            <b-col cols="12" md="10" align-self="start">
                                <b-button variant="outline-primary" class="btn-r5 shadow" @click="clearData">
                                    <i class="material-icons">add</i>
                                    <span>Agregar<br>Nuevo</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" v-b-modal.favorite>
                                    <i class="material-icons">star</i>
                                    <span>Seleccione<br>Favorito</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" v-b-modal.qrReader>
                                    <i class="material-icons">qr_code_scanner</i>
                                    <span>Escanear<br>QR</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" v-b-modal.manualCode>
                                    <i class="material-icons">dialpad</i>
                                    <span>Agregar<br>Código</span>
                                </b-button>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name + ':'">
                                    <b-form-input name="name" v-model="form.name" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('name')" :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading" aria-describedby="name-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{ veeErrors.first('name')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.lname + ':'">
                                    <b-form-input name="lname" v-model="form.lname" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('lname')" :data-vv-as="(labels.lname).toLowerCase()"
                                        :disabled="loading" aria-describedby="lname-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="lname-live-feedback">{{ veeErrors.first('lname')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mname + ':'">
                                    <b-form-input name="mname" v-model="form.mname" type="text" class="text-center"
                                        v-validate="'alpha_spaces|max:19'" :state="validateState('mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()" :disabled="loading"
                                        aria-describedby="mname-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="mname-live-feedback">{{ veeErrors.first('mname')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.td + ':'">
                                    <b-form-select name="td" :options="td" :value="form.td" v-model="form.td"
                                        class="form-control select-center" v-validate="'required:true'"
                                        :state="validateState('td')" :data-vv-as="(labels.td).toLowerCase()"
                                        :disabled="loading" aria-describedby="td-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="td-live-feedback">{{ veeErrors.first('td')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.nd + ':'">
                                    <b-form-input name="nd" v-model="form.nd" :type="typeND ? 'text' : 'number'"
                                        :inputmode="typeND ? 'text' : 'numeric'" class="text-center"
                                        v-validate="'required:true' + validateND" :state="validateState('nd')"
                                        :data-vv-as="(labels.nd).toLowerCase()" :disabled="loading"
                                        aria-describedby="nd-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="nd-live-feedback">{{ veeErrors.first('nd')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.issuedBy + ':'">
                                    <b-form-select name="issuedBy" :options="countries_list" :value="form.issuedBy"
                                        v-model="form.issuedBy" v-validate="'required:true'"
                                        :state="validateState('issuedBy')" :data-vv-as="(labels.issuedBy).toLowerCase()"
                                        :disabled="loading" aria-describedby="issuedBy-live-feedback"
                                        class="form-control" value-field="iso2" text-field="name"></b-form-select>
                                    <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.email + ':'">
                                    <b-form-input name="email" v-model="form.email" type="text" inputmode="email"
                                        class="text-center" v-validate="'required:true|email'"
                                        :state="validateState('email')" :data-vv-as="(labels.email).toLowerCase()"
                                        :disabled="loading" aria-describedby="email-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mobile + ':'">
                                    <b-form-input name="mobile" v-model="form.mobile" type="text" inputmode="numeric"
                                        class="text-center" v-validate="'required:true|numeric' + vMobile"
                                        :state="validateState('mobile')" :data-vv-as="(labels.mobile).toLowerCase()"
                                        :disabled="loading" aria-describedby="mobile-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="mobile-live-feedback">{{ veeErrors.first('mobile')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" v-if="form.payReceiver === 'Bank'">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.payReceiver === 'Bank'">
                                <b-form-group :label="labels.tc + ':'">
                                    <b-form-select name="tc" :options="tc" :value="form.tc" v-model="form.tc"
                                        class="form-control select-center" v-validate="'required:true'"
                                        :state="validateState('tc')" :data-vv-as="(labels.tc).toLowerCase()"
                                        :disabled="loading" aria-describedby="tc-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="tc-live-feedback">{{ veeErrors.first('tc')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.payReceiver === 'Bank'">
                                <b-form-group :label="labels.nc + ':'">
                                    <b-form-input name="nc" v-model="form.nc" :type="typeNC ? 'text' : 'number'"
                                        :inputmode="typeNC ? 'text' : 'numeric'" class="text-center"
                                        v-validate="'required:true' + validateNC" :state="validateState('nc')"
                                        :data-vv-as="(labels.nc).toLowerCase()" :disabled="loading"
                                        aria-describedby="nc-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="nc-live-feedback">{{ veeErrors.first('nc')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start"
                                v-if="form.payReceiver === 'Bank' && form.country === 'AR'">
                                <b-form-group :label="labels.cbu + ':'">
                                    <b-form-input name="cbu" v-model="form.cbu" type="number" inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true|digits:22|cbu|is_not:' + '0'.repeat(22)"
                                        :state="validateState('cbu')" :data-vv-as="(labels.cbu).toLowerCase()"
                                        :disabled="loading" aria-describedby="cbu-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="cbu-live-feedback">{{ veeErrors.first('cbu')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start"
                                v-if="form.payReceiver === 'Bank' && form.country === 'BR'">
                                <b-form-group :label="labels.nab + ':'">
                                    <b-form-input name="nab" v-model="form.nab" type="number" inputmode="numeric"
                                        class="text-center" v-validate="'required:true'" :state="validateState('nab')"
                                        :data-vv-as="(labels.nab).toLowerCase()" :disabled="loading"
                                        aria-describedby="nab-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="nab-live-feedback">{{ veeErrors.first('nab')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start"
                                v-if="form.payReceiver === 'Bank' && form.country === 'BR'">
                                <b-form-group :label="labels.cpf + ':'">
                                    <b-form-input name="cpf" v-model="form.cpf" type="number" inputmode="numeric"
                                        class="text-center" v-validate="'required:true|digits:11'"
                                        :state="validateState('cpf')" :data-vv-as="(labels.cpf).toLowerCase()"
                                        :disabled="loading" aria-describedby="cpf-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="cpf-live-feedback">{{ veeErrors.first('cpf')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.address + ':'">
                                    <b-form-input name="address" v-model="form.address" type="text" class="text-center"
                                        v-validate="'required:true|min:3|max:70'" :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()" :disabled="loading"
                                        aria-describedby="address-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="address-live-feedback">{{ veeErrors.first('address')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.district + ':'">
                                    <b-form-input name="district" v-model="form.district" type="text"
                                        class="text-center" v-validate="'required:true|min:3|max:35'"
                                        :state="validateState('district')" :data-vv-as="(labels.district).toLowerCase()"
                                        :disabled="loading" aria-describedby="district-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="district-live-feedback">{{ veeErrors.first('district')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city + ':'">
                                    <b-form-input name="city" v-model="form.city" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('city')" :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading" aria-describedby="city-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="city-live-feedback">{{ veeErrors.first('city')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state + ':'">
                                    <b-form-input name="state" v-model="form.state" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('state')" :data-vv-as="(labels.state).toLowerCase()"
                                        :disabled="loading" aria-describedby="state-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="state-live-feedback">{{ veeErrors.first('state')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <!-- Modal Search Receiver -->
                            <b-modal id="favorite" centered no-fade header-class="text-center"
                                header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                title="Buscar Beneficiario" tabindex="-1" role="dialog" size="lg" aria-hidden="true">
                                <b-form id="formFavorites" @submit.stop.prevent="getDataReceiver('favorite')">
                                    <b-row align-h="center">
                                        <b-col cols="12" sm="10" md="9" class="mb-3" align-self="start">
                                            <b-form-group :label="labels.favorite + ':'">
                                                <v-select :options="accounts" v-model="accountSelected"
                                                    :searchable="true" :disabled="loadingFavs"
                                                    labelTitle="-- Por favor seleccione un beneficiario --"
                                                    labelNotFound="El destinatario no existe"
                                                    labelSearchPlaceholder="Buscar Destinatario"
                                                    :textProp="form.payReceiver === 'Cash' ? 'ftext' : 'text'" />
                                                <b-form-select v-show="false" name="favorite" :options="accounts"
                                                    :value="form.accountID" v-model="form.accountID"
                                                    class="form-control select-center"
                                                    v-validate="'required:true|excluded:0'"
                                                    :state="validateState('favorite')"
                                                    :data-vv-as="(labels.favorite).toLowerCase()"
                                                    :disabled="loadingFavs" aria-describedby="favorite-live-feedback"
                                                    value-field="id"
                                                    :text-field="form.payReceiver === 'Cash' ? 'ftext' : 'text'"></b-form-select>
                                                <b-form-invalid-feedback id="favorite-live-feedback">{{
                                                    veeErrors.first('favorite')
                                                    }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" align-self="center">
                                            <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                                                form="formFavorites" :disabled="loadingFavs">
                                                <b-spinner small type="grow" v-if="loadingFavs"></b-spinner>
                                                <b-icon icon="check-all" aria-hidden="true" v-else></b-icon>
                                                &nbsp;&nbsp;<span>{{ loadingFavs ? 'Aplicando...' : 'Aplicar' }}</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-modal>

                            <!-- Modal QR Reader -->
                            <b-modal id="qrReader" centered no-fade header-class="text-center"
                                header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                title="Lector de QR" tabindex="-1" role="dialog" aria-hidden="true">
                                <b-row align-h="center">
                                    <b-col cols="12" align-self="center">
                                        <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
                                            <div v-if="qrReaderLoading" class="loading-indicator m-3">
                                                Iniciando Cámara ...
                                            </div>
                                            <div v-if="validationSuccess" class="validation-success">
                                                <img :src="checkIcon" alt="Checkmark" />
                                                El QR ha sido verificado exitosamente!
                                            </div>
                                            <div v-if="validationFailure" class="validation-failure">
                                                <img :src="uncheckIcon" alt="Xmark" />
                                                La verificación del QR ha fallado!
                                            </div>
                                            <div v-if="validationPending" class="validation-pending">
                                                <img :src="loadIcon" alt="Synchronization" />
                                                Verificación de QR en progreso...
                                            </div>
                                        </qrcode-stream>
                                    </b-col>
                                </b-row>
                            </b-modal>

                            <!-- Modal Manual Insert -->
                            <b-modal id="manualCode" centered no-fade header-class="text-center"
                                header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                title="Ingresar Código de Forma Manual" tabindex="-1" role="dialog" size="lg"
                                @hidden="result = null" aria-hidden="true">
                                <b-form id="formClientCode" @submit.stop.prevent="getDataReceiver('manualCode', 1)">
                                    <b-row align-h="center">
                                        <b-col cols="12" sm="10" md="9" class="mb-3" align-self="start">
                                            <b-form-group :label="labels.clientCode + ':'">
                                                <b-form-input name="manualCode" v-model="result" type="text"
                                                    class="text-center" v-validate="'required:true'"
                                                    :state="validateState('manualCode')"
                                                    :data-vv-as="(labels.clientCode).toLowerCase()"
                                                    :disabled="loadingFavs" aria-describedby="manualCode-live-feedback"
                                                    placeholder="Ej: 5bc8c567a89112d5f408a8af4f17970d"></b-form-input>
                                                <b-form-invalid-feedback id="manualCode-live-feedback">{{
                                                    veeErrors.first('manualCode')
                                                    }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" align-self="center">
                                            <b-button type="submit" variant="default" pill :disabled="loadingFavs"
                                                class="shadow px-5" form="formClientCode" size="lg">
                                                <b-spinner small type="grow" v-if="loadingFavs"></b-spinner>
                                                <b-icon icon="check-all" aria-hidden="true" v-else></b-icon>
                                                &nbsp;&nbsp;<span>{{ loadingFavs ? 'Aplicando...' : 'Aplicar' }}</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-modal>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 4">
                            <b-col>
                                <b-row align-h="center">
                                    <b-col cols="6" sm="5" md="4" lg="3" align-self="start" class="my-md-4"
                                        v-if="imageData !== null">
                                        <img :src="imageData" width="100%" alt="voucher"
                                            style="border: 1px solid #eee; border-radius: 4px;" />
                                    </b-col>
                                </b-row>
                                <b-row align-h="center">
                                    <b-col cols="12" md="5" align-self="start" class="my-md-4">
                                        <b-form-group :label="labels.payment + ':'">
                                            <b-form-select name="pay_method" :value="form.pay_method" v-model="form.pay_method"
                                                :options="payments" v-validate="'required:true'"
                                                :state="validateState('pay_method')"
                                                :data-vv-as="(labels.payment).toLowerCase()"
                                                aria-describedby="pay_method-live-feedback"
                                                class="form-control select-center"
                                                :disabled="loading" size="lg"></b-form-select>
                                            <b-form-invalid-feedback id="pay_method-live-feedback">{{
                                                veeErrors.first('pay_method')
                                            }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <!--
                                    Ramas dormidas del antiguo "Método de Pago" (códigos payment 1/2/4).
                                    En el flujo partner el giro siempre se financia desde el saldo, por lo que
                                    `form.payment` queda fijo en 3 y estos bloques nunca se mostraban. Se dejan
                                    comentados como referencia (subir comprobante, portal de pagos, agentes de recaudo).

                                    <b-col cols="12" md="5" align-self="start" class="my-md-4"
                                        v-if="form.payment === 2">
                                        <b-form-group :label="labels.voucher + ':'" label-align="center">
                                            <b-form-file name="voucher" v-model="form.voucher"
                                                v-validate="'required:true|image|size:5120'"
                                                :data-vv-as="(labels.voucher).toLowerCase()"
                                                aria-describedby="voucher-live-feedback"
                                                :state="form.voucher ? Boolean(form.voucher) : form.voucher || validateState('voucher')"
                                                placeholder="Seleccione un archivo ..."
                                                drop-placeholder="Suelta el archivo aquí ..." accept="image/*"
                                                browse-text="Buscar" size="lg"></b-form-file>
                                            <b-form-invalid-feedback id="voucher-live-feedback">
                                                veeErrors.first('voucher')
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="center" class="my-md-4"
                                        v-if="form.payment === 4">
                                        <b-button variant="default" pill class="my-4 mb-md-0 px-5 py-2"
                                            v-b-modal.partners>
                                            <b-icon icon="geo-alt-fill" class="mr-1"></b-icon>
                                            <span>Ver Oficinas y Agentes</span>
                                        </b-button>
                                    </b-col>

                                    Textos informativos por código de payment (1 portal, 2 transferencia, 3 saldo, 4 agentes)
                                    y el modal "Oficinas y Agentes" tambien quedan fuera de uso.
                                -->
                            </b-col>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 5">
                            <b-col cols="12" md="10" class="my-md-5">
                                <p class="text-center">
                                    <strong>Por favor revise bien los datos ingresados antes de enviar esta
                                        solicitud</strong>
                                </p>
                            </b-col>
                            <b-col cols="12" md="10" class="mb-3">
                                <b-form-group label="Código Promocional (opcional):" label-class="text-center">
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model="promo.code"
                                            placeholder="Ingresa el código"
                                            class="text-uppercase text-center"
                                            :disabled="promo.loading"
                                            @input="promo.code = promo.code.toUpperCase()"
                                            @keyup.enter.prevent="validatePromo"></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="primary" :disabled="promo.loading || !promo.code" @click="validatePromo">
                                                <b-spinner small v-if="promo.loading"></b-spinner>
                                                <span v-else>Aplicar</span>
                                            </b-button>
                                            <b-button variant="outline-secondary" v-if="promo.applied || promo.code" @click="clearPromo">
                                                <i class="material-icons mdi mdi-close"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-success" v-if="promo.applied">
                                        ✓ Código <strong>{{ promo.applied.code }}</strong> aplicado: {{ promo.applied.discount_percent }}% de descuento
                                    </small>
                                    <small class="text-danger" v-else-if="promo.error">{{ promo.error }}</small>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" class="text-center">
                                <b-table-simple stacked>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th class="text-center">Datos Ingresados</b-th>
                                            <b-td stacked-heading="Nombres">{{ form.name }}</b-td>
                                            <b-td stacked-heading="Apellidos">{{ form.lname }} {{ form.mname }}</b-td>
                                            <b-td stacked-heading="Documento">{{ form.td }} - {{ form.nd }}</b-td>
                                            <b-td stacked-heading="Email">{{ form.email }}</b-td>
                                            <b-td stacked-heading="Teléfono">{{ form.mobile }}</b-td>
                                            <b-td stacked-heading="Oficina" v-if="form.payReceiver === 'Cash'">{{
                                                form.nOffice }}</b-td>
                                            <b-td stacked-heading="Banco" v-if="form.payReceiver === 'Bank'">{{
                                                form.nBank }}</b-td>
                                            <b-td stacked-heading="Cuenta" v-if="form.payReceiver === 'Bank'">{{ form.tc
                                            }} {{ form.nc }}</b-td>
                                            <b-td stacked-heading="Dirección">{{ form.address }} {{ form.district }}, {{
                                                form.city }} - {{
                                                    form.state }}, {{ form.country }}</b-td>
                                            <b-td stacked-heading="Monto Enviado">{{ Number((form.type === 'S' ?
                                                form.value : form.convert) -
                                                fee).toLocaleString('en-US', {
                                                    minimumFractionDigits: ((form.currency ===
                                                        'USD' && form.type ===
                                                        'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0),
                                                    maximumFractionDigits:
                                                        ((form.currency === 'USD' && form.type === 'S') || (form.cConvert ===
                                                            'USD' && form.type ===
                                                            'R') ? 2 : 0)
                                                }) }} {{ form.type === 'S' ? form.currency : form.cConvert
                                                }}</b-td>
                                            <b-td stacked-heading="Comisión">{{ Number(fee_net).toLocaleString('en-US',
                                                {
                                                    minimumFractionDigits:
                                                        ((form.currency === 'USD' && form.type === 'S') || (form.cConvert ===
                                                            'USD' && form.type ===
                                                            'R') ? 2 : 0), maximumFractionDigits: ((form.currency === 'USD' &&
                                                                form.type === 'S') ||
                                                                (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0)
                                                }) }} {{
                                                    form.type === 'S' ?
                                                        form.currency : form.cConvert }}</b-td>
                                            <b-td stacked-heading="IVA">{{ Number(tax_amount).toLocaleString('en-US',
                                                {
                                                    minimumFractionDigits:
                                                        ((form.currency === 'USD' && form.type === 'S') || (form.cConvert ===
                                                            'USD' && form.type ===
                                                            'R') ? 2 : 0), maximumFractionDigits: ((form.currency === 'USD' &&
                                                                form.type === 'S') ||
                                                                (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0)
                                                }) }} {{
                                                    form.type === 'S' ?
                                                        form.currency : form.cConvert }}</b-td>
                                            <b-td stacked-heading="Descuento" v-if="promo.applied" class="text-success">
                                                <strong>- {{ Number(promo_discount_amount).toLocaleString('en-US', {
                                                    minimumFractionDigits: ((form.currency === 'USD' && form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0),
                                                    maximumFractionDigits: ((form.currency === 'USD' && form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0)
                                                }) }} {{ form.type === 'S' ? form.currency : form.cConvert }}</strong>
                                                <small class="d-block">Código {{ promo.applied.code }}</small>
                                            </b-td>
                                            <b-td stacked-heading="Total a Pagar">{{ Number(total_pagar).toLocaleString('en-US', {
                                                    minimumFractionDigits:
                                                        ((form.currency === 'USD' &&
                                                            form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2
                                                            : 0),
                                                    maximumFractionDigits: ((form.currency === 'USD' && form.type === 'S')
                                                        || (form.cConvert ===
                                                            'USD' && form.type === 'R') ? 2 : 0)
                                                }) }} {{ form.type === 'S' ?
                                                    form.currency : form.cConvert
                                                }}</b-td>
                                            <b-td stacked-heading="Monto Destino">{{ Number(form.type === 'S' ?
                                                form.convert :
                                                form.value).toLocaleString('en-US', {
                                                    minimumFractionDigits:
                                                        ((form.cConvert === 'COP' &&
                                                            form.type === 'S') || (form.currency === 'COP' && form.type === 'R') ? 0
                                                            : 2),
                                                    maximumFractionDigits: ((form.cConvert === 'COP' && form.type === 'S')
                                                        || (form.currency ===
                                                            'COP' && form.type === 'R') ? 0 : 2)
                                                }) }} {{ form.type === 'S' ?
                                                    form.cConvert : form.currency
                                                }}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-col>
                            <b-col cols="12" md=8 align-self="start">
                                <b-form-group :label="labels.cash + ':'">
                                    <b-input-group>
                                        <template #prepend>
                                            <b-input-group-text class="m-0 px-sm-4 btrr-0 bbrr-0">
                                                <b>{{ form.currency === 'PEN' ? 'S/.' : '$' }}</b>
                                            </b-input-group-text>
                                        </template>
                                        <currency-input v-model="form.cash" name="cash" v-validate="'required:true'"
                                            :state="validateState('cash')" aria-describedby="cash-live-feedback"
                                            :data-vv-as="(labels.cash).toLowerCase()" :disabled="loading"
                                            :precision="currency_precision"
                                            class="text-right text-sm-center form-control form-control-lg"
                                            style="padding: 0.5rem 1rem; background-image: none;" />
                                        <template #append>
                                            <b-input-group-text class="m-0 px-sm-4 btlr-0 bblr-0">
                                                <b>{{ form.type === 'S' ? form.currency : form.cConvert
                                                }}</b></b-input-group-text>
                                        </template>
                                    </b-input-group>
                                    <b-form-invalid-feedback id="amount-live-feedback">{{
                                        veeErrors.first('amount')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <h4
                                    :class="form.cash < total_pagar ? 'text-danger' : 'text-success'">
                                    Cambio:
                                    {{ (parseFloat(form.cash ? form.cash : 0) - total_pagar).toLocaleString('en-US') }}
                                    {{ form.type === 'S' ? form.currency : form.cConvert }}</h4>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-button v-if="current_step > 1" class="float-left" variant="secondary" @click="onClickBack">{{
                            back }}</b-button>
                        <b-button v-if="current_step === max_step" class="float-right" variant="success"
                            @click="onClickFinish" :disabled="loading">{{ finish }}</b-button>
                        <b-button v-else class="float-right" variant="default" @click="onClickNext"
                            :disabled="loading">{{ next }}</b-button>
                    </b-form>
                </b-card>
            </b-col>
            <b-col cols="12" sm="10" md="8" align-self="center" v-else>
                <b-card bg-variant="transparent" align="center" class="text-center">
                    <h5 class="my-5 mx-2">Debes tener asignado el rol de cajero y una sucursal para poder realizar
                        pagos.</h5>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";
import { CurrencyInput } from 'vue-currency-input';
import VSelect from '@alfsnd/vue-bootstrap-select';

export default {
    name: "PartnerRequest",
    props: ['user'],
    components: {
        CurrencyInput,
        VSelect
    },
    data: () => ({
        loading: false,
        loadingSends: false,
        loadingFavs: false,
        current_step: 1,
        max_step: 5,
        title: 'Datos del Remitente',
        subtitle: '',
        partner: {},
        labels: {
            sender: 'Enviador',
            favorite: 'Destinatario',
            clientCode: 'Código del Destinatario',

            country: 'País de Destino',
            type: 'Método de Envío',
            payReceiver: 'Forma de Pago en Destino',
            value: 'Valor a Pagar',

            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            rut: 'RUT',
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            issuedBy: 'País de emisión',
            expiration: 'Fecha de Vencimiento',
            noExp: 'Sin Fecha de Vencimiento',
            email: 'Correo Electrónico',
            mobile: 'Teléfono',
            birthday: 'Fecha de Nacimiento',
            profession: 'Profesión',
            pep: '¿Eres Persona Expuesta Políticamente?',

            office: 'Oficinas de Cobro',

            bank: 'Entidad Bancaria',
            wallet: 'Wallet',
            tc: 'Tipo de Cuenta',
            nc: 'Número de Cuenta',
            cbu: 'Número CBU/CVU',
            cpf: 'Número CPF',
            nab: 'Número de Agencia Bancaria',

            address: 'Dirección',
            district: 'Comuna',
            zipcode: 'Código Postal',
            city: 'Ciudad',
            state: 'Región',

            payment: 'Forma de Pago',
            voucher: 'Comprobante de Pago',
            convert: 'Monto en Destino',

            es: {
                labelPrevDecade: 'Década Anterior',
                labelPrevYear: 'Año Anterior',
                labelPrevMonth: 'Mes Anterior',
                labelCurrentMonth: 'Mes Actual',
                labelNextMonth: 'Próximo Mes',
                labelNextYear: 'Próximo Año',
                labelNextDecade: 'Próxima Década',
                labelToday: 'Hoy',
                labelSelected: 'Fecha Seleccionada',
                labelNoDateSelected: 'Sin fecha seleccionada',
                labelCalendar: 'Calendario',
                labelNav: 'Navegar por el calendario',
                labelHelp: 'Use las teclas de flecha para navegar por el calendario'
            },
            cash: 'Valor Recibido'
        },
        form: {
            sender: {
                id: 0,
                name: null,
                lname: null,
                mname: null,
                td: null,
                nd: null,
                rut: null,
                issuedBy: null,
                expiration: null,
                email: null,
                mobile: null,
                birthday: null,
                profession: null,
                pep: 0,

                address: null,
                district: null,
                zipcode: null,
                city: null,
                state: null,
                country: 'CL'
            },
            country: 'PE',
            type: 'S',
            payReceiver: 'Bank',
            value: 0,
            currency: 'CLP',

            accountID: 0,
            name: null,
            lname: null,
            mname: null,
            td: null,
            nd: null,
            issuedBy: null,
            email: null,
            mobile: null,

            office: null,
            nOffice: null,

            bank: null,
            nBank: null,
            wallet: null,
            nWallet: null,
            tc: null,
            nc: null,
            cbu: null,
            cpf: null,
            nab: null,

            address: null,
            district: null,
            city: null,
            state: null,

            rate: 0,
            convert: 0,
            cConvert: null,
            base: 0,

            payment: 3, // Canal de financiamiento: el giro del partner siempre se descuenta del saldo (Mi Saldo).
            pay_method: 'EFECTIVO', // Forma de pago del cliente en mostrador.

            voucher: null,
            payer: null,
            payer_code: null,
            cash: 0
        },
        countries: [
            { text: 'AR - Argentina', value: 'AR' },
            { text: 'BO - Bolivia', value: 'BO' },
            { text: 'BR - Brasil', value: 'BR' },
            { text: 'CO - Colombia', value: 'CO' },
            { text: 'DE - Alemania', value: 'DE' },
            { text: 'DO - Rep. Dominicana', value: 'DO' },
            { text: 'EC - Ecuador', value: 'EC' },
            { text: 'ES - España', value: 'ES' },
            { text: 'FR - Francia', value: 'FR' },
            { text: 'HT - Haiti', value: 'HT' },
            { text: 'IT - Italia', value: 'IT' },
            { text: 'MX - México', value: 'MX' },
            { text: 'PE - Perú', value: 'PE' },
            { text: 'US - Estados Unidos', value: 'US' },
            { text: 'VE - Venezuela', value: 'VE' }
        ],
        types: [
            { text: 'Remitente', value: 'S', disabled: false }, // Sender
            { text: 'Beneficiario', value: 'R', disabled: false } // Receiver
        ],
        payReceivers: [
            { text: 'Abono a Cta', value: 'Bank', disabled: false },
            { text: 'Ventanilla', value: 'Cash', disabled: false },
            { text: 'Wallet', value: 'Wallet', disabled: false }
        ],
        currencies: [
            { tm: 1, code: 'CLP', type: 'S', country: 'CL', name: 'Pesos Chilenos' },
            { tm: 2, code: 'USD', type: 'S', country: 'CL', name: 'Dolares' },
            { tm: 1, code: 'PEN', type: 'R', country: 'PE', name: 'Nuevos Soles', enabled: true },
            { tm: 2, code: 'USD', type: 'R', country: 'PE', name: 'Dolares', enabled: true }
        ],
        collections: [],
        quoteTimeout: null,
        quotingTerrapay: false,
        payments: [
            { text: 'Efectivo', value: 'EFECTIVO' },
            { text: 'Transferencia', value: 'TRANSFERENCIA' },
            { text: 'Débito/Crédito', value: 'DEBITO_CREDITO' }
        ],
        countries_list: [],
        accounts: [],
        accountSelected: null,
        senders: [],
        senderSelected: null,
        sender_td: [
            { value: 'RUT', text: 'RUT' },
            { value: 'DNI', text: 'Documento Nacional de Identidad' },
            { value: 'CI', text: 'Cedula de Identidad' },
            { value: 'CE', text: 'Cedula de Extranjeria' },
            { value: 'PS', text: 'Pasaporte' }
        ],
        offices: [],
        officeSelected: null,
        banks: [],
        wallets: [],
        walletSelected: null,
        bankSelected: null,
        tc: [
            { value: 'Ahorros', text: 'Cuenta de Ahorros' },
            { value: 'Corriente', text: 'Cuenta Corriente' }
        ],
        professions: [
            { name: 'Ingeniero/a' },
            { name: 'Estudiante' },
            { name: 'Comerciante' },
            { name: 'Empresario/a' },
            { name: 'Abogado/a' },
            { name: 'Administrador/a' },
            { name: 'Médico/a' },
            { name: 'Arquitecto/a' },
            { name: 'Economista' },
            { name: 'Profesor/a' },
            { name: 'Programador/a' },
            { name: 'Amo/a de Casa' },
            { name: 'Artísta ó Artesano/a' },
            { name: 'Rentista de Capital' },
            { name: 'Policía ó Militar' },
            { name: 'Agricultor/a, Ganadero/a ó Pescador/a' },
            { name: 'Técnico/a' },
            { name: 'Otra' }
        ],
        yes_no: [
            { code: 0, text: 'No' },
            { code: 1, text: 'Si' }
        ],
        minDateExp: undefined,
        minDate: undefined,
        maxDate: undefined,
        back: 'Atras',
        next: 'Siguiente',
        finish: 'Finalizar',
        camera: 'auto',
        isValid: undefined,
        loadIcon: '/img/synchronization.svg',
        uncheckIcon: '/img/x-mark.svg',
        checkIcon: '/img/checkmark.svg',
        qrReaderLoading: false,
        fileName: '',
        result: null,
        imageData: null,
        feeData: [],
        fee: 0,
        promo: {
            code: '',
            applied: null,
            loading: false,
            error: null,
        },
        minData: {},
        min: 0,
        maxData: {},
        max: 0,
        quotes: [],
        currency_precision: 0,
        mask: '##.###.###-N'
    }),
    mounted() {
        this.server = '/moreg'
        this.$emit('loader');
        this.$emit('section', 'requestpage');
        this.form.country = this.$route.query.country ? this.$route.query.country : 'PE';
        this.form.type = this.$route.query.type ? this.$route.query.type : 'S';
        this.form.currency = this.$route.query.currency ? this.$route.query.currency : 'CLP';
        this.form.value = parseFloat(this.$route.query.value ? (this.$route.query.value).toString() : 0);
        if (this.form.currency !== 'CLP' && this.form.currency !== 'COP') {
            this.currency_precision = 2;
        }
        this.getIni();
        this.getDate();
        this.getSenders();
    },
    watch: {
        senderSelected() {
            if (!this.senderSelected || !this.senderSelected.id) {
                this.form.sender.id = 0;
                return;
            }
            this.form.sender.id = this.senderSelected.id;
            this.accountSelected = null;
            this.form.accountID = 0;
            this.getReceivers();
        },
        'form.sender.id'() {
            if (this.form.sender.id === 0) {
                this.senderSelected = null;
            } else {
                let senders = this.senders;

                for (let i = 0; i < senders.length; i++) {
                    if (senders[i].id === this.form.sender.id) {
                        this.senderSelected = senders[i];
                    }
                }
            }
        },
        accountSelected() {
            let accounts = this.accounts;

            for (let i = 0; i < accounts.length; i++) {
                if (accounts[i] === this.accountSelected) {
                    this.form.accountID = accounts[i].id;
                }
            }
        },
        'form.accountID'() {
            if (this.form.accountID === 0) {
                this.accountSelected = null;
            } else {
                let accounts = this.accounts;

                for (let i = 0; i < accounts.length; i++) {
                    if (accounts[i].id === this.form.accountID) {
                        this.accountSelected = accounts[i];
                    }
                }
            }
        },
        'form.sender.td'() {
            if (this.form.sender.td === 'RUT') {
                this.form.sender.nd = null;
            } else {
                this.form.sender.rut = null;
            }
        },
        'form.sender.nd'() {
            if (this.form.sender.nd) {
                this.form.sender.nd = (this.form.sender.nd).toUpperCase();
            }
        },
        'form.sender.rut'() {
            if (this.form.sender.rut) {
                this.form.sender.rut = (this.form.sender.rut).toUpperCase();
                if (this.form.sender.td === 'RUT') {
                    this.form.sender.nd = this.form.sender.rut;
                }
            }
        },
        'form.country'() {
            this.bankSelected = null;
            this.officeSelected = null;
            this.resetData(this.form.sender, this.form.country, this.form.type, this.form.currency, this.form.value);
            this.getIni();
        },
        'form.payReceiver'() {
            if (this.form.payReceiver === 'Cash' && (this.form.country === 'BR' || this.form.country === 'VE')) {
                this.form.payReceiver = 'Bank';
            }
            this.payReceivers[1].disabled = (this.form.country === 'BR' || this.form.country === 'VE');
            if (this.form.payReceiver === 'Cash') {
                this.bankSelected = null;
                this.walletSelected = null;
                this.officeSelected = this.offices[0];
            } else if (this.form.payReceiver === 'Bank') {
                this.officeSelected = null;
                this.walletSelected = null;
                this.bankSelected = this.banks[0];
            } else if (this.form.payReceiver === 'Wallet') {
                this.officeSelected = null;
                this.bankSelected = null;
                this.walletSelected = this.wallets[0];
            }
        },
        walletSelected() {
            if (this.walletSelected) {
                let wallets = this.wallets;
                for (let i = 0; i < wallets.length; i++) {
                    if (wallets[i] === this.walletSelected) {
                        this.form.wallet = wallets[i].code;
                        this.form.nWallet = wallets[i].name;
                        this.form.payer_code = wallets[i].payer_id;
                        this.form.payer = wallets[i].group;
                    }
                }
            } else {
                this.form.bank = null;
                this.form.nBank = null;
            }
        },
        officeSelected() {
            if (this.officeSelected) {
                let offices = this.offices;

                for (let i = 0; i < offices.length; i++) {
                    if (offices[i] === this.officeSelected) {
                        this.form.office = offices[i].code;
                        this.form.nOffice = offices[i].name;
                        this.form.payer_code = offices[i].payer_id;
                        this.form.payer = offices[i].group;
                    }
                }
            } else {
                this.form.office = null;
                this.form.nOffice = null;
            }
        },
        bankSelected() {
            if (this.bankSelected) {
                let banks = this.banks;
                for (let i = 0; i < banks.length; i++) {
                    if (banks[i] === this.bankSelected) {
                        this.form.bank = banks[i].code;
                        this.form.nBank = banks[i].name;
                        this.form.payer_code = banks[i].payer_id;
                        this.form.payer = banks[i].group;
                    }
                }
            } else {
                this.form.bank = null;
                this.form.nBank = null;
            }
        },
        'form.payer_code'() {
            this.getSettings();
            console.log('form.payer_code getSettings()')
        },
        'form.type'() {
            this.labels.value = 'Valor a Pagar';
            this.labels.convert = 'Monto en Destino';
            if (this.form.type === 'R') {
                this.labels.value = 'Monto en Destino';
                this.labels.convert = 'Valor a Pagar';
            }
            this.form.rate = 0;
            this.form.convert = 0;
            this.form.cConvert = null;
            this.quotes = [];
            this.getCurrency();
        },
        'form.value'() {
            this.getQuotes();
        },
        'form.currency'() {
            let decimals = 2;
            let collections = this.collections;
            let min = this.minData.data.value;
            let max = this.maxData.data.value;
            let payer = this.form.payer;
            if (this.form.type === "S") {
                let fee = 0;
                let feeData = this.feeData;
                for (let u = 0; u < feeData.length; u++) {
                    if (min > feeData[u].data.min && min <= feeData[u].data.max && payer === feeData[u].data.payer) {
                        let fc = 0;
                        let ft = feeData[u].item;
                        let fv = feeData[u].data.value;
                        let ftc = feeData[u].data.tc;
                        let fvc = feeData[u].data.com;

                        if (ft === '%') {
                            if (ftc === '%') {
                                fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                fee = (min / 100) * fc;
                            } else {
                                fee = (min / 100) * fv;
                                fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                            }
                        } else if (ft === '=') {
                            fc = fvc;
                            if (ftc === '%') {
                                fc = (min / 100) * fvc;
                            }
                            fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                        }
                    }
                }
                min = min + fee;
            }
            for (let i = 0; i < collections.length; i++) {
                if (collections[i].code_send === this.form.currency &&
                    collections[i].country_send === this.form.sender.country) {
                    if (collections[i].code_send !== 'USD') {
                        decimals = 0;
                        min = min / collections[i].value;
                        max = max / collections[i].value;
                    }
                } else if (collections[i].code_receiver === this.form.currency &&
                    collections[i].country_receiver === this.form.country) {
                    if (collections[i].code_receiver !== 'USD') {
                        min = min * collections[i].value;
                        max = max * collections[i].value;
                    }
                }
            }
            console.log(`MIN:`, min, `MAX:`, max, `DECIMALS:`, decimals);
            this.min = parseFloat(min.toFixed(decimals));
            this.max = parseFloat(max.toFixed(decimals));
            if (this.form.value >= min && this.form.value <= max) {
                this.getQuotes();
            } else {
                this.form.value = 0;
            }
            this.currency_precision = this.form.currency === 'CLP' || this.form.currency === 'COP' ? 0 : 2;
        },
        'form.convert'() {
            let fee = 0;
            let fx_rate = 1;
            let quotes = this.quotes;

            for (let i = 0; i < quotes.length; i++) {
                if (quotes[i].value === this.form.convert) {
                    this.form.cConvert = quotes[i].code;
                    fee = parseFloat((quotes[i].data.fee).toFixed(2));
                    if (this.form.type === 'S' && this.form.currency !== 'USD') {
                        fee = parseFloat((quotes[0].data.fee).toFixed(2));
                    }
                }
                let cSend = this.form.currency;
                let cReceiver = this.form.cConvert;
                if (this.form.type === 'R') {
                    cSend = this.form.cConvert;
                    cReceiver = this.form.currency;
                }
                if (cSend !== cReceiver) {
                    if (cSend === quotes[i].data.code_send) {
                        if (this.form.type === 'S') {
                            fx_rate = quotes[i].data.fx;
                        } else if (this.form.type === 'R') {
                            fx_rate = fx_rate * quotes[i].data.fx;
                        }
                    } else if (cReceiver === quotes[i].data.code_receiver) {
                        if (this.form.type === 'S') {
                            fx_rate = fx_rate * quotes[i].data.fx;
                        } else if (this.form.type === 'R') {
                            fx_rate = quotes[i].data.fx;
                        }
                    }
                }
            }
            this.fee = fee;
            this.form.rate = fx_rate;
            // Si había un código promocional aplicado, re-validar contra el nuevo fee.
            if (this.promo.applied && this.promo.code) {
                this.validatePromo();
            }
        },
        total_pagar(newVal, oldVal) {
            // Al aplicar/quitar código promocional o cambiar el monto, sincronizar
            // form.cash con el nuevo total para que el "Valor Recibido" refleje el
            // monto efectivo a pagar (con descuento aplicado).
            if (this.form.cash === oldVal || !this.form.cash) {
                this.form.cash = newVal;
            }
        },
        'form.td'() {
            if (!/^([0-9])*$/.test(this.form.nd) && this.form.td !== 'PS') {
                this.form.nd = null;
            }
            if (this.form.td === 'PS' && this.form.nd) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.nd'() {
            if (this.typeND) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.bank'() {
            if (this.form.bank) {
                this.getReceivers();
            }
        },
        'form.nc'() {
            if (this.typeNC) {
                this.form.nc = (this.form.nc).toUpperCase();
            }
        },
    },
    computed: {
        tax_rate() {
            // Obtener el tax_rate del feeData actual
            if (this.feeData && this.feeData.length > 0) {
                for (let i = 0; i < this.feeData.length; i++) {
                    if (this.feeData[i].data && this.feeData[i].data.tax !== undefined) {
                        return this.feeData[i].data.tax;
                    }
                }
            }
            return 0;
        },
        send_decimals() {
            // CLP/COP no usan decimales; USD/PEN sí.
            const currency = this.form.type === 'S' ? this.form.currency : this.form.cConvert;
            return currency === 'USD' || currency === 'PEN' ? 2 : 0;
        },
        fee_final() {
            // Comisión final aplicando código promocional si existe.
            return this.promo.applied ? this.promo.applied.fee_total_final : this.fee;
        },
        promo_discount_amount() {
            // Redondeo a la precisión de la moneda para que coincida con el display
            // y el cambio del cajero quede exacto.
            if (!this.promo.applied) return 0;
            const f = Math.pow(10, this.send_decimals);
            return Math.round(this.promo.applied.discount_amount * f) / f;
        },
        total_pagar() {
            // Total que paga el cliente, con descuento aplicado si existe.
            const baseTotal = this.form.type === 'S' ? Number(this.form.value || 0) : Number(this.form.convert || 0);
            const f = Math.pow(10, this.send_decimals);
            return Math.round((baseTotal - this.promo_discount_amount) * f) / f;
        },
        fee_net() {
            // Comisión sin IVA, calculada sobre el fee final (con descuento si aplica).
            if (this.fee_final > 0 && this.tax_rate > 0) {
                return this.fee_final / (1 + this.tax_rate);
            }
            return this.fee_final;
        },
        tax_amount() {
            // IVA recalculado sobre el fee final.
            return this.fee_final - this.fee_net;
        },
        td() {
            let td = [
                { value: 'DNI', text: 'Documento Nacional de Identidad' },
                { value: 'CI', text: 'Cedula de Identidad' },
                { value: 'CE', text: 'Cedula de Extranjeria' },
                { value: 'PS', text: 'Pasaporte' }
            ];
            if (this.form.country === 'AR' && this.form.payReceiver === 'Bank') {
                td = [
                    { value: 'CUIT', text: 'CUIT/CUIL' }
                ];
                this.form.td = 'CUIT';
            } else if (this.form.country === 'CO' && this.form.payer === 'HSTECH') {
                td = [
                    { value: 'NIT', text: 'Número de Identificación Tributaria' }
                ];
                this.form.td = 'NIT';
            }
            return td;
        },
        typeND() {
            return this.form.td === 'PS' || (this.form.td === 'CI' && this.form.country === 'BO') ||
                this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT';
        },
        validateND() {
            let nd = '';
            if (this.form.td !== 'PS') {
                if (this.form.country === 'AR') {
                    if (this.form.payReceiver === 'Bank') {
                        nd += '|numeric|digits:11|cuit';
                    } else {
                        nd += '|numeric|digits:8';
                    }
                } else if (this.form.country === 'CO') {
                    nd += '|numeric|min:6';
                    if (this.form.td === 'CE') {
                        nd += '|max:7';
                    } else {
                        nd += '|max:10';
                    }
                } else if (this.form.country === 'EC') {
                    nd += '|numeric|min:10|max:15';
                } else if (this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                    this.form.country === 'IT') {
                    nd += '|min:6|max:19|alpha_num|tn';
                }
            } else if (this.form.country === 'AR') {
                nd += '|min:8|max:10';
            }
            return nd;
        },
        vMobile() {
            let m = '';
            if (this.form.country === 'AR') {
                m += '|digits:11';
            } else if (this.form.country === 'CO') {
                m += '|digits:10';
            } else if (this.form.country === 'EC' || this.form.country === 'PE') {
                m += '|digits:9';
            }
            return m;
        },
        typeNC() {
            return this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT';
        },
        validateNC() {
            let nc = '|numeric';
            if (this.form.country === 'VE') {
                nc += '|digits:20';
            } else if (this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT') {
                nc = '|min:14|max:32|alpha_num|tn';
            } else if (this.form.country === 'CO') {
                let bank = this.form.bank !== null ? (this.form.bank).slice(4) : '';
                if (bank === 'CCAICOBB' || bank === 'PICHCOBB' || bank === 'BPOPCOBB') {
                    nc += '|min:9|max:12';
                } else if (bank === 'BAVICOBB') {
                    nc += '|min:9';
                    if (this.form.tc === 'Ahorros') {
                        nc += '|max:11';
                    } else if (this.form.tc === 'Corriente') {
                        nc += '|max:13';
                    }
                } else if (bank === 'CASOCOBB' || bank === 'FIACCOB1') {
                    nc += '|min:11|max:12';
                } else if (bank === 'COLPCOBB') {
                    nc += '|min:9|max:10';
                } else if (bank === 'CAFECOBB') {
                    nc += '|min:12|max:16';
                } else if (bank === 'OCCICOBC' || bank === 'BCTOCOBB' || bank === 'LP001292') {
                    nc += '|digits:9';
                } else if (bank === 'CITICO21' || bank === 'LP001507') {
                    nc += '|digits:10';
                } else if (bank === 'COLOCOBM') {
                    nc += '|digits:11';
                } else if (bank === 'FALACOBB') {
                    nc += '|digits:12';
                } else if (bank === 'PRCBCOBB' || (bank === 'LP001289' && this.form.tc === 'Corriente')) {
                    nc += '|digits:13';
                } else if (bank === 'FBBVCOBB') {
                    nc += '|min:9|max:20';
                } else if (bank === 'BSUDCOBB') {
                    nc += '|min:8|max:11';
                }
            } else if (this.form.country === 'BO') {
                const code = this.form.bank != null ? String(this.form.bank) : '';
                if (window.BO_JETPERU_WALLET_BANK_CODES.includes(code)) {
                    nc += '|digits:8|bo_wallet_phone';
                } else {
                    nc += '|min:5|max:20';
                }
            } else if (this.form.country === 'EC') {
                nc += '|min:6|max:34';
            }
            return nc;
        },
        progress() {
            return Math.round(100 / this.max_step) * this.current_step;
        },
        validationPending() {
            return this.isValid === undefined
                && this.camera === 'off';
        },
        validationSuccess() {
            return this.isValid === true;
        },
        validationFailure() {
            return this.isValid === false;
        }
    },
    methods: {
        async validatePromo() {
            const code = (this.promo.code || '').trim().toUpperCase();
            if (!code) {
                this.promo.applied = null;
                this.promo.error = null;
                return;
            }
            if (!this.fee || this.fee <= 0) {
                this.promo.error = 'Calcula la comisión primero';
                return;
            }
            this.promo.loading = true;
            this.promo.error = null;
            try {
                const res = await axios.post(`${this.server}/api/partner/promo-codes/validate`, {
                    code,
                    fee_total: this.fee,
                    tax_rate: this.tax_rate,
                    partner_earnings_pct: 0,
                });
                if (res.data && res.data.valid) {
                    this.promo.applied = {
                        code: res.data.code,
                        discount_percent: res.data.discount_percent,
                        description: res.data.description,
                        discount_amount: res.data.preview.discount_amount,
                        fee_total_final: res.data.preview.fee_total_final,
                    };
                    this.promo.error = null;
                } else {
                    this.promo.applied = null;
                    this.promo.error = (res.data && res.data.msg) ? res.data.msg : 'Código no válido';
                }
            } catch (e) {
                this.promo.applied = null;
                this.promo.error = (e.response && e.response.data && e.response.data.msg) ? e.response.data.msg : 'Error validando código';
            } finally {
                this.promo.loading = false;
            }
        },
        clearPromo() {
            this.promo.code = '';
            this.promo.applied = null;
            this.promo.error = null;
        },
        getRCurrency(n) {
            this.currencies = [
                { tm: 1, code: 'CLP', type: 'S', country: 'CL', name: 'Pesos Chilenos' },
                { tm: 2, code: 'USD', type: 'S', country: 'CL', name: 'Dolares' }
            ];

            if (n > 1) {
                let code = 'EUR';
                let name = 'Euros';
                let value = false;
                if (this.form.country === 'AR') {
                    code = 'ARS';
                    name = 'Pesos Argentinos';
                } else if (this.form.country === 'BO') {
                    code = 'BOB';
                    name = 'Bolivianos';
                    value = true;
                } else if (this.form.country === 'BR') {
                    code = 'BRL';
                    name = 'Reales';
                } else if (this.form.country === 'CO') {
                    code = 'COP';
                    name = 'Pesos Colombianos';
                } else if (this.form.country === 'HT') {
                    code = 'HTG';
                    name = 'Gourde';
                    value = true;
                } else if (this.form.country === 'DO') {
                    code = 'DOP';
                    name = 'Pesos Dominicanos';
                    value = true;
                } else if (this.form.country === 'PE') {
                    code = 'PEN';
                    name = 'Nuevos Soles';
                    value = true;
                } else if (this.form.country === 'VE') {
                    code = 'VES';
                    name = 'Bolivares';
                }

                this.currencies[2] = { tm: 1, code: code, type: 'R', country: this.form.country, name: name, enabled: true };
                this.currencies[3] = { tm: 2, code: 'USD', type: 'R', country: this.form.country, name: 'Dolares', enabled: value };
            } else {
                this.currencies[2] = { tm: 2, code: 'USD', type: 'R', country: this.form.country, name: 'Dolares', enabled: true };
            }
        },
        getIni() {
            this.loading = true;
            this.getBanks();
            this.getOffices();
            this.getWallets();
        },
        getBanks() {
            this.banks = [];
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/banks').then((res) => {
                this.banks = res.data.banks;
                if (this.form.payReceiver === 'Bank' && this.bankSelected === null) {
                    this.bankSelected = res.data.banks[0];
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getOffices() {
            this.offices = [];
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/offices').then((res) => {
                let offices = res.data.offices;
                for (let i = 0; i < offices.length; i++) {
                    offices[i].name = offices[i].payer + ' - ' + offices[i].name + ' - ' + offices[i].city;
                }
                this.offices = offices;
                if ((this.offices).length > 0) {
                    if (this.form.payReceiver === 'Cash' && this.officeSelected === null) {
                        this.officeSelected = res.data.offices[0];
                    }
                } else {
                    if (this.form.payReceiver === 'Cash') {
                        this.form.payReceiver = 'Bank';
                        this.officeSelected = null;
                    }
                    this.payReceivers[1].disabled = true;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getWallets() {
            this.wallets = [];
            let country = this.form.country;
            axios.get(`${this.server}/api/partner/wallets/${country}`).then((res) => {
                let wallets = res.data;
                this.wallets = wallets;
                if (this.form.payReceiver === 'Wallet' && this.walletSelected === null) {
                    this.walletSelected = wallets[0];
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getSettings() {
            this.loading = true;
            let send = this.form.sender.country;
            let receiver = this.form.country;
            let payer = this.form.payer ? this.form.payer : 0;
            let payer_id = this.form.payer_code ? this.form.payer_code : 0;
            let urlSettings = `${this.server}/api/partner/request/settings/` + payer + '/' + payer_id + '/' + send + '/' + receiver
            console.log('URL SETTINGS:', urlSettings);
            axios.get(urlSettings).then((res) => {
                console.log('SETTINGS:', res.data);
                if (res.data.status === 'success') {
                    this.countries_list = res.data.countries;
                    this.collections = res.data.currencies;
                    this.minData = res.data.min;
                    this.maxData = res.data.max;
                    this.feeData = res.data.fee;
                    this.partner = res.data.partner;
                    this.getRCurrency((res.data.currencies).length);

                    let decimals = 2;
                    let collections = res.data.currencies;
                    let min = res.data.min.data.value;
                    let max = res.data.max.data.value;
                    if (this.form.type === "S") { // Sender o Remitente
                        let fee = 0;
                        let feeData = res.data.fee;
                        for (let u = 0; u < feeData.length; u++) {
                            if (min > feeData[u].data.min && min <= feeData[u].data.max &&
                                payer === feeData[u].data.payer) {
                                let fc = 0;
                                let ft = feeData[u].item;
                                let fv = feeData[u].data.value;
                                let ftc = feeData[u].data.tc;
                                let fvc = feeData[u].data.com;
                                let tax = feeData[u].data.tax;
                                if (ft === '%') {
                                    if (ftc === '%') {
                                        fc = ((fv - fvc) * (1 + tax)) + fvc;
                                        fee = (min / 100) * fc;
                                    } else {
                                        fee = (min / 100) * fv;
                                        fee = ((fee - fvc) * (1 + tax)) + fvc;
                                    }
                                } else if (ft === '=') {
                                    fc = fvc;
                                    if (ftc === '%') {
                                        fc = (min / 100) * fvc;
                                    }
                                    fee = ((fv - fc) * (1 + tax)) + fc;
                                }
                                console.log(`VALOR:${fv}`)
                                console.log(`TAX:${tax}`)
                                console.log(`COM:${fvc}`)
                                console.log(`FT:${ft}`)
                                console.log(`FEE:${fee}`)
                                console.log(`MIN1:${fee}`)
                            }
                        }
                        min = min + fee;
                        console.log(`MIN2:${fee}`)
                    }
                    for (let i = 0; i < collections.length; i++) {
                        if (collections[i].code_send === this.form.currency &&
                            collections[i].country_send === this.form.sender.country) {
                            if (collections[i].code_send !== 'USD') {
                                decimals = 0;
                                min = min / collections[i].value;
                                max = max / collections[i].value;
                            }
                        } else if (collections[i].code_receiver === this.form.currency &&
                            collections[i].country_receiver === this.form.country) {
                            if (collections[i].code_receiver !== 'USD') {
                                min = min * collections[i].value;
                                max = max * collections[i].value;
                            }
                        }
                    }
                    this.min = parseFloat(min.toFixed(decimals));
                    this.max = parseFloat(max.toFixed(decimals));
                    console.log(`this.min1:${this.min}`)
                    console.log(`this.max1:${this.max}`) 
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
                this.getCurrency();
                if (this.form.sender.id) {
                    this.getReceivers();
                }
                if (this.form.value > this.min && this.form.value <= this.max) {
                    this.getQuotes();
                } else {
                    this.form.value = 0;
                }
            });
        },
        getDate() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 100 años menos
            const minDate = new Date(today)
            minDate.setFullYear(minDate.getFullYear() - 100)
            // 18 años menos
            const maxDate = new Date(today)
            maxDate.setFullYear(maxDate.getFullYear() - 18)

            this.minDate = minDate;
            this.maxDate = maxDate;
            this.minDateExp = today;
        },
        getSenders() {
            this.senders = [];

            axios.get('/api/partner/senders').then((res) => {
                if (res.data.status === 'success') {
                    let senders = res.data.senders;
                    for (let i = 0; i < senders.length; i++) {
                        if (senders[i].country === this.form.sender.country) {
                            this.senders.push(senders[i]);
                        }
                    }
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getReceivers() {
            this.accounts = [];
            const id = this.form.sender.id;
            // Ya no pasamos country ni bank como filtros - el backend solo filtra por partner_id (agente)
            // Usamos valores por defecto para mantener la compatibilidad con la ruta
            const country = this.form.country || 'all';
            const bank = 'all'; // Siempre 'all' para no filtrar por banco
            if (id > 0) {
                axios.get('/api/partner/senders/' + id + '/' + country + '/' + bank + '/receivers').then((res) => {
                    if (res.data.status === 'success') {
                        let favs = res.data.favorites;
                        // Mostramos todos los destinatarios del agente sin filtros
                        for (let i = 0; i < favs.length; i++) {
                            this.accounts.push(favs[i]);
                        }
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                });
            }
        },
        getVoucher() {
            const input = this.form.voucher;

            if (input) {
                const reader = new FileReader;
                reader.onload = e => {
                    this.imageData = e.target.result;
                };
                reader.readAsDataURL(input);
            }
        },
        clearVoucher() {
            this.form.voucher = null;
            this.imageData = null;
        },
        getCurrency() {
            if (this.$route.query.type !== this.form.type) {
                this.form.currency = 'CLP';
                if (this.form.type === 'R') {
                    this.form.currency = 'EUR';
                    if (this.form.country === 'AR') {
                        this.form.currency = 'ARS';
                    } else if (this.form.country === 'BO') {
                        this.form.currency = 'BOB';
                    } else if (this.form.country === 'BR') {
                        this.form.currency = 'BRL';
                    } else if (this.form.country === 'CO') {
                        this.form.currency = 'COP';
                    } else if (this.form.country === 'HT') {
                        this.form.currency = 'HTG';
                    } else if (this.form.country === 'DO') {
                        this.form.currency = 'DOP';
                    } else if (this.form.country === 'EC' || this.form.country === 'US') {
                        this.form.currency = 'USD';
                    } else if (this.form.country === 'PE') {
                        this.form.currency = 'PEN';
                    } else if (this.form.country === 'VE') {
                        this.form.currency = 'VES';
                    }
                }
                this.$route.query.type = null;
            }

            if (this.form.value >= this.min && this.form.value <= this.max) {
                this.getQuotes();
            } else {
                this.form.value = 0;
            }
        },
        getQuotes() {
            this.$validator.validate('value').then(result => {
                if (!result) {
                    return;
                }
                let quotes = [];
                if (this.form.value > 0) {
                    let fee = 0;
                    let feeData = this.feeData;
                    console.log(`FEEDATA:`, feeData)
                    let ft = '%';
                    let fv = 0;
                    let ftc = '%';
                    let fvc = 0;
                    let type = this.form.type;
                    let amount = this.form.value;
                    let currency = this.form.currency;
                    let currencies = this.currencies;
                    let collections = this.collections;
                    console.log(`CURRENCY:`, currency)
                    console.log(`COLLECTIONS:`, collections)
                    let payer = this.form.payer;

                    for (let i = 0; i < currencies.length; i++) {
                        // abono a cuenta
                        // Sender o Remitente
                        if (type === 'S' && currencies[i].code === currency) {
                            console.log(`currencies[i].tm:${currencies[i].tm}`)
                            if (currencies[i].tm === 1) {
                                for (let f = 0; f < collections.length; f++) {
                                    console.log(`F:${f}`)
                                    for (let u = 0; u < feeData.length; u++) {
                                        let val = amount * collections[f].value;
                                        console.log(`VAL:${val}=amount:${amount} * collections[f].value:${collections[f].value}`)
                                        if (val > feeData[u].data.min && val <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            let count = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;
                                            console.log(`u:${u},amount:${amount},FT:${ft},FV:${fv},FTC:${ftc},FVC:${fvc}`)
                                            if (ft === '%' && fee === 0) {
                                                console.log(`(ft === '%' && fee === 0)`)
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = amount - (amount / (1 + (0.01 * fc)));
                                                } else {
                                                    /** ACA */
                                                    fc = fvc;
                                                    console.log(`FC1:${fc}`)
                                                    console.log(`collections[f].code_send: ${collections[f].code_send},currency: ${currency}`)
                                                    if (collections[f].code_send === currency) {
                                                        console.log(`collections[f].value:${collections[f].value}`)
                                                        fc = fc / collections[f].value;
                                                    }
                                                    console.log(`FC2:${fc}`) 
                                                    fv = fv * (1 + feeData[u].data.tax);
                                                    console.log(`FV:${fv}`)
                                                    fee = amount - (amount / (1 + (0.01 * fv)));
                                                    console.log(`FEE1:${fee}`) 
                                                    fee = fee - (fc * feeData[u].data.tax) / (1 + (0.01 * fv));
                                                    console.log(`FEE2:${fee}`)
                                                }

                                            } else if (ft === '=' && fee === 0) {
                                                console.log(`(ft === '=' && fee === 0)`)
                                                fc = fvc;
                                                fee = fv;
                                                if (collections[f].code_send === currency) {
                                                    fee = fv / collections[f].value;
                                                }
                                                if (ftc === '%') {
                                                    fc = amount - (amount / (1 + (0.01 * fc)));
                                                } else if (ftc === '=' && collections[f].code_send === currency) {
                                                    fc = fc / collections[f].value;
                                                }
                                                fee = ((fee - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (collections[f].code_send === currency) {
                                                console.log(`collections[f].code_send === currency`)
                                                let amount_receiver = (amount - fee) * collections[f].value;
                                                console.log(`currency:${currency}, amount_receiver:${amount_receiver.toFixed(2)}=(amount:${amount} - fee:${fee}) * collections[${f}].value:${collections[f].value}`)
                                                currency = collections[f].code_receiver;
                                                quotes.push({
                                                    text: Number(amount_receiver.toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(amount_receiver.toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: fee,
                                                        fee_usd: parseFloat(collections[f].code_send === 'USD' ? fee : fee * collections[f].value),
                                                        tax: feeData[u].data.tax,
                                                        amount_send: amount,
                                                        code_send: collections[f].code_send,
                                                        country_send: collections[f].country_send,
                                                        amount_receiver,
                                                        code_receiver: currency,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                                fee = parseFloat(fee * collections[f].value);
                                                amount = parseFloat((amount * collections[f].value).toFixed(2));
                                                count++;
                                            }

                                            if (f === collections.length && count === 0) {
                                                let amount_receiver = amount - fee
                                                quotes.push({
                                                    text: Number((amount - fee).toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat((amount_receiver).toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: 1,
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        tax: feeData[u].data.tax,
                                                        amount_send: amount,
                                                        code_send: currency,
                                                        country_send: this.form.local,
                                                        amount_receiver,
                                                        code_receiver: currency,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            } else if (currencies[i].tm === 2) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        if (amount > feeData[u].data.min && amount <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;
                                            console.log(`tm === 2, u:${u},amount:${amount},FT:${ft},FV:${fv},FTC:${ftc},FVC:${fvc}`)
                                            if (ft === '%') {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = amount - (amount / (1 + (0.01 * fc)));
                                                } else {
                                                    fc = fvc;
                                                    fv = fv * (1 + feeData[u].data.tax);
                                                    fee = amount - (amount / (1 + (0.01 * fv)));
                                                    fee = fee - ((fc * feeData[u].data.tax) / (1 + (0.01 * fv)));
                                                    console.log(`FEE:${fee}`)
                                                }
                                            } else if (ft === '=') {
                                                fc = fvc;
                                                fee = fv;
                                                if (ftc === '%') {
                                                    fc = amount - (amount / (1 + (0.01 * fc)));
                                                }
                                                fee = ((fee - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (!quotes[0]) {
                                                let amount_receiver = amount - fee
                                                quotes.push({
                                                    text: Number((amount_receiver).toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat((amount_receiver).toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: 1,
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        tax: feeData[u].data.tax,
                                                        amount_send: amount,
                                                        code_send: collections[f].code_send,
                                                        country_send: collections[f].country_send,
                                                        amount_receiver,
                                                        code_receiver: collections[f].code_send,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }

                                            if (collections[f].code_send === currency) {
                                                let value = (amount - fee) * collections[f].value;
                                                console.log(`value ${value}= (amount:${amount} - fee:${fee}) * collections[f].value:${collections[f].value}`)
                                                currency = collections[f].code_receiver;
                                                quotes.push({
                                                    text: Number(value.toFixed(collections[f].code_receiver === 'COP' ? 0 : 2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(collections[f].code_receiver === 'COP' ? 0 : 2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        tax: feeData[u].data.tax,
                                                        amount_send: amount,
                                                        code_send: collections[f].code_send,
                                                        country_send: collections[f].country_send,
                                                        amount_receiver: value,
                                                        code_receiver: currency,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                            // Receiver o Beneficiario
                        } else if (type === 'R' && currencies[i].code === currency) {
                            if (currencies[i].tm === 1) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        let value = amount / collections[f].value;
                                        if (value > feeData[u].data.min && value <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;

                                            if (ft === '%') {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = (value / 100) * fc;
                                                } else {
                                                    fee = (value / 100) * fv;
                                                    fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                }
                                            } else if (ft === '=') {
                                                fc = fvc;
                                                if (ftc === '%') {
                                                    fc = (value / 100) * fvc;
                                                }
                                                fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (collections[f].code_receiver === currency) {
                                                value = value + fee;
                                                currency = collections[f].code_send;
                                                quotes.push({
                                                    text: Number(value.toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        tax: feeData[u].data.tax,
                                                        amount_send: value,
                                                        code_send: currency,
                                                        country_send: collections[f].country_send ? collections[f].country_send : this.form.local,
                                                        amount_receiver: amount,
                                                        code_receiver: collections[f].code_receiver,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                                amount = value - fee;
                                            }
                                        }
                                    }
                                }
                            } else if (currencies[i].tm === 2) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        if (amount > feeData[u].data.min && amount <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;

                                            if (ft === '%') {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = (amount / 100) * fc;
                                                } else {
                                                    fee = (amount / 100) * fv;
                                                    fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                }
                                            } else if (ft === '=') {
                                                fc = fvc;
                                                if (ftc === '%') {
                                                    fc = (amount / 100) * fvc;
                                                }
                                                fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (!quotes[0]) {
                                                quotes.push({
                                                    text: Number((amount + fee).toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat((amount + fee).toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: 1,
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        tax: feeData[u].data.tax,
                                                        amount_send: parseFloat(amount + fee),
                                                        code_send: collections[f].code_receiver,
                                                        country_send: collections[f].country_send ? collections[f].country_send : this.form.local,
                                                        amount_receiver: amount,
                                                        code_receiver: collections[f].code_receiver,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }

                                            if (collections[f].code_receiver === currency) {
                                                let value = (amount + fee) / collections[f].value;
                                                currency = collections[f].code_send;
                                                quotes.push({
                                                    text: Number(value.toFixed(collections[f].code_send === 'CLP' ? 0 : 2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(collections[f].code_send === 'CLP' ? 0 : 2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: parseFloat(fee / collections[f].value),
                                                        fee_usd: fee,
                                                        tax: feeData[u].data.tax,
                                                        amount_send: parseFloat(value),
                                                        code_send: currency,
                                                        country_send: collections[f].country_send ? collections[f].country_send : this.form.local,
                                                        amount_receiver: amount,
                                                        code_receiver: collections[f].code_receiver,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (quotes[0]) {
                        quotes[0].disabled = (this.form.country === 'AR' || this.form.country === 'BR' || this.form.country === 'CO' || this.form.country === 'VE') && type === 'S';
                        this.form.convert = quotes[1] ? quotes[1].value : quotes[0].value;
                    }
                    this.quotes = quotes;
                    console.log(`QUOTES:`, quotes)

                    // Si el payer es TERRAPAY, consultar la API para obtener el monto real
                    if (this.form.payer === 'TERRAPAY' && this.form.value > 0 && type === 'S') {
                        this.debouncedQuoteTerrapay();
                    }
                }
            });
        },
        debouncedQuoteTerrapay() {
            clearTimeout(this.quoteTimeout);
            this.quoteTimeout = setTimeout(() => {
                this.fetchTerrapayQuote();
            }, 500);
        },
        fetchTerrapayQuote() {
            const valorConvertir = this.form.value - this.fee;
            if (valorConvertir <= 0) return;

            this.quotingTerrapay = true;
            const country = this.form.country;
            const currency = this.form.cConvert;

            axios.get(`${this.server}/api/partner/request/quote-terrapay/${country}/${currency}/${valorConvertir}`)
                .then((res) => {
                    if (res.data.status === 'success' && res.data.receivingAmount != null) {
                        const realAmount = parseFloat(res.data.receivingAmount);
                        const fxRate = res.data.fxRate ? parseFloat(res.data.fxRate) : null;
                        const precision = (currency === 'COP' || currency === 'CLP') ? 0 : 2;
                        const formattedAmount = parseFloat(realAmount.toFixed(precision));

                        for (let i = 0; i < this.quotes.length; i++) {
                            if (this.quotes[i].code === currency) {
                                this.quotes[i].value = formattedAmount;
                                this.quotes[i].text = Number(formattedAmount).toLocaleString('en-US') + ' ' + currency;
                                this.quotes[i].data.amount_receiver = realAmount;
                                if (fxRate) {
                                    this.quotes[i].data.fx = fxRate;
                                }
                            }
                        }

                        this.form.convert = formattedAmount;
                    }
                })
                .catch((err) => {
                    console.error('Error cotizando Terrapay:', err);
                })
                .finally(() => {
                    this.quotingTerrapay = false;
                });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        onClickNext() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.current_step++;
                this.updateTitle(this.current_step);
            });
        },
        onClickBack() {
            this.current_step--;
            this.updateTitle(this.current_step);
        },
        updateTitle(v) {
            this.title = 'Datos del Remitente';
            if (v === 2) {
                this.title = 'Detalles de Envío';
            } else if (v === 3) {
                this.title = 'Datos del Destinatario';
            } else if (v === 4) {
                this.title = 'Método de Pago';
            } else if (v === 5) {
                this.title = 'Resumen';
            }
        },
        onClickFinish() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;

                let formData = new FormData();

                formData.append('sender_id', this.form.sender.id);
                formData.append('sender_name', this.form.sender.name);
                formData.append('sender_lname', this.form.sender.lname);
                formData.append('sender_mname', this.form.sender.mname);
                formData.append('sender_td', this.form.sender.td);
                formData.append('sender_nd', this.form.sender.nd);
                formData.append('sender_rut', this.form.sender.rut);
                formData.append('sender_issuedBy', this.form.sender.issuedBy);
                formData.append('sender_expiration', this.form.sender.expiration);
                formData.append('sender_email', this.form.sender.email);
                formData.append('sender_mobile', this.form.sender.mobile);
                formData.append('sender_birthday', this.form.sender.birthday);
                formData.append('sender_profession', this.form.sender.profession);
                formData.append('sender_pep', this.form.sender.pep);

                formData.append('sender_address', this.form.sender.address);
                formData.append('sender_district', this.form.sender.district);
                formData.append('sender_zipcode', this.form.sender.zipcode);
                formData.append('sender_city', this.form.sender.city);
                formData.append('sender_state', this.form.sender.state);
                formData.append('sender_country', this.form.sender.country);

                formData.append('country', this.form.country);
                formData.append('type', this.form.type);
                formData.append('payReceiver', this.form.payReceiver);
                formData.append('value', this.form.value);
                formData.append('currency', this.form.currency);

                formData.append('account_id', this.form.accountID);
                formData.append('name', this.form.name);
                formData.append('lname', this.form.lname);
                formData.append('mname', this.form.mname);
                formData.append('td', this.form.td);
                formData.append('nd', this.form.nd);
                formData.append('issuedBy', this.form.issuedBy);
                formData.append('email', this.form.email);
                formData.append('mobile', this.form.mobile);

                formData.append('office', this.form.office);

                formData.append('bank', this.form.bank);
                formData.append('wallet', this.form.wallet);
                formData.append('tc', this.form.tc);
                formData.append('nc', this.form.nc);
                formData.append('cbu', this.form.cbu);
                formData.append('cpf', this.form.cpf);
                formData.append('nab', this.form.nab);

                formData.append('address', this.form.address);
                formData.append('district', this.form.district);
                formData.append('city', this.form.city);
                formData.append('state', this.form.state);

                formData.append('fee', this.fee);
                formData.append('rate', this.form.rate);
                formData.append('convert', this.form.convert);
                formData.append('cConvert', this.form.cConvert);

                formData.append('payment', this.form.payment);
                formData.append('pay_method', this.form.pay_method);
                formData.append('voucher', this.form.voucher);
                formData.append('payer', this.form.payer);
                formData.append('payer_code', this.form.payer_code);
                formData.append('quotes', JSON.stringify(this.quotes));
                if (this.promo.applied) {
                    formData.append('promo_code', this.promo.applied.code);
                }
                let url = `${this.server}/api/partner/request/send`;
                axios.post(url, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(res => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.$emit('notifications');
                    if (res.data.status === 'success' || res.data.status === 'info') {
                        this.$router.push({ name: 'PartnerResult' });
                    } else if (res.data.status === 'warning') {
                        this.$router.push({ name: 'PartnerCollect' });
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                });
            });
        },
        async onInit(promise) {
            this.qrReaderLoading = true;

            try {
                await promise;
            } catch (e) {
                console.error(e);
            } finally {
                this.resetValidationState();
                this.qrReaderLoading = false;
            }
        },
        async onDecode(content) {
            this.result = content;
            this.turnCameraOff();

            await this.getDataReceiver('qrReader', 1);
        },
        getDataSender(k) {
            this.$validator.validate(k).then(result => {
                if (!result) {
                    return;
                }
                this.loadingSends = true;
                if (this.form.sender.id > 0) {
                    let items = this.senders;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === this.form.sender.id) {
                            let lname = (items[i].lname).split(', ', 2);

                            this.form.sender.name = items[i].name;
                            this.form.sender.lname = lname[0];
                            this.form.sender.mname = lname[1] ? lname[1] : '';
                            this.form.sender.td = items[i].td;
                            if (items[i].td === 'RUT') {
                                this.form.sender.nd = null;
                                this.form.sender.rut = items[i].nd;
                            } else {
                                this.form.sender.nd = items[i].nd;
                                this.form.sender.rut = null;
                            }
                            this.form.sender.issuedBy = items[i].issuedBy;
                            this.form.sender.expiration = items[i].expiration;
                            this.form.sender.email = items[i].email;
                            this.form.sender.mobile = items[i].mobile;
                            this.form.sender.birthday = items[i].birthday;
                            this.form.sender.profession = items[i].profession;
                            this.form.sender.pep = items[i].pep;
                            this.form.sender.address = items[i].address;
                            this.form.sender.district = items[i].district;
                            this.form.sender.zipcode = items[i].zipcode;
                            this.form.sender.city = items[i].city;
                            this.form.sender.state = items[i].state;
                            this.$bvModal.hide(k);
                        }
                    }
                }
                this.loadingSends = false;
            });
        },
        getDataReceiver(k, v) {
            this.$validator.validate(k).then(result => {
                if (!result) {
                    return;
                }
                this.loadingFavs = true;
                const pay = this.form.payReceiver;
                if (v) {
                    let formData = new FormData();
                    formData.append('id', this.result);
                    formData.append('country', this.form.country);
                    axios.post('/api/partner/details', formData).then(res => {
                        if (res.data.status === 'success') {
                            const receiver = res.data.receiver;
                            let lname = (receiver.lname).split(', ', 2);

                            this.form.name = receiver.name;
                            this.form.lname = lname[0];
                            this.form.mname = lname[1] ? lname[1] : '';
                            this.form.td = receiver.td;
                            this.form.nd = receiver.nd;
                            this.form.issuedBy = receiver.issuedBy;
                            this.form.email = receiver.email;
                            this.form.mobile = receiver.mobile;
                            if (pay === 'Bank') {
                                //this.form.office = null;
                                //this.form.bank = receiver.bank;
                                this.form.tc = receiver.tc;
                                this.form.nc = receiver.nc;
                                if (this.form.country === 'AR') {
                                    this.form.cbu = receiver.details.cbu;
                                }
                                if (this.form.country === 'BR') {
                                    this.form.cpf = receiver.details.cpf;
                                    this.form.nab = receiver.details.nab;
                                }
                            } else if (pay === 'Cash') {
                                //this.form.office = null;
                                //this.form.bank = null;
                                this.form.tc = null;
                                this.form.nc = null;
                                if (this.form.country === 'AR') {
                                    this.form.cbu = null;
                                }
                                if (this.form.country === 'BR') {
                                    this.form.cpf = null;
                                    this.form.nab = null;
                                }
                            }
                            this.form.address = receiver.address;
                            this.form.district = receiver.district;
                            this.form.city = receiver.city;
                            this.form.state = receiver.state;

                            this.isValid = true;
                            this.$bvModal.hide(k);
                            setTimeout(this.reloadCamera, 2000);
                        } else {
                            this.$root.$bvToast.toast(res.data.msg, {
                                title: 'Notificación',
                                headerClass: 'd-none',
                                variant: res.data.status,
                                toaster: 'b-toaster-top-right',
                                autoHideDelay: 5000,
                                solid: true,
                                appendToast: true
                            });
                            this.isValid = false;
                            this.turnCameraOn();
                            setTimeout(this.reloadCamera, 3000);
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).then(() => {
                        this.loadingFavs = false;
                    });
                } else {
                    if (this.form.accountID > 0) {
                        let items = this.accounts;
                        for (let i = 0; i < items.length; i++) {
                            if (items[i].id === this.form.accountID) {
                                let lname = (items[i].lname).split(', ', 2);

                                this.form.name = items[i].name;
                                this.form.lname = lname[0];
                                this.form.mname = lname[1] ? lname[1] : '';
                                this.form.td = items[i].td;
                                this.form.nd = items[i].nd;
                                this.form.issuedBy = items[i].issuedBy;
                                this.form.email = items[i].email;
                                this.form.mobile = items[i].mobile;
                                if (pay === 'Bank') {
                                    //this.form.office = null;
                                    //this.form.bank = items[i].bank;
                                    this.form.tc = items[i].tc;
                                    this.form.nc = items[i].nc;
                                    if (this.form.country === 'AR') {
                                        this.form.cbu = items[i].details.cbu;
                                    }
                                    if (this.form.country === 'BR') {
                                        this.form.cpf = items[i].details.cpf;
                                        this.form.nab = items[i].details.nab;
                                    }
                                } else if (pay === 'Cash') {
                                    //this.form.office = null;
                                    //this.form.bank = null;
                                    this.form.tc = null;
                                    this.form.nc = null;
                                    if (this.form.country === 'AR') {
                                        this.form.cbu = null;
                                    }
                                    if (this.form.country === 'BR') {
                                        this.form.cpf = null;
                                        this.form.nab = null;
                                    }
                                }
                                this.form.address = items[i].address;
                                this.form.district = items[i].district;
                                this.form.city = items[i].city;
                                this.form.state = items[i].state;
                                this.isValid = true;
                                this.$bvModal.hide(k);
                            }
                        }
                    }
                    this.loadingFavs = false;
                }
            });
        },
        clearData(type) {
            if (type === 'sender') {
                this.form.sender.id = 0;
                this.form.sender.name = null;
                this.form.sender.lname = null;
                this.form.sender.mname = null;
                this.form.sender.td = null;
                this.form.sender.nd = null;
                this.form.sender.issuedBy = null;
                this.form.sender.expiration = null;
                this.form.sender.rut = null;
                this.form.sender.email = null;
                this.form.sender.mobile = null;
                this.form.sender.pep = 0;

                this.form.sender.address = null;
                this.form.sender.district = null;
                this.form.sender.zipcode = null;
                this.form.sender.city = null;
                this.form.sender.state = null;
            } else {
                this.form.accountID = 0;
                this.form.name = null;
                this.form.lname = null;
                this.form.mname = null;
                this.form.td = null;
                this.form.nd = null;
                this.form.issuedBy = null;
                this.form.email = null;
                this.form.mobile = null;

                //this.form.office = null;
                //this.form.bank = null;
                this.form.tc = null;
                this.form.nc = null;
                this.form.cbu = null;
                this.form.cpf = null;
                this.form.nab = null;

                this.form.address = null;
                this.form.district = null;
                this.form.city = null;
                this.form.state = null;
            }

            this.$validator.reset();
            this.$root.$bvToast.toast('¡Ingrese los nuevos datos!', {
                title: 'Felicitaciones',
                headerClass: 'd-none',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        },
        turnCameraOn() {
            this.camera = 'auto';
        },
        turnCameraOff() {
            this.camera = 'off';
        },
        reloadCamera() {
            this.isValid = undefined;
        },
        resetData(sender, country, type, currency, value) {
            let payer = this.form.payer;
            let payReceiver = this.form.payReceiver;
            this.form = {
                sender: sender,
                country: country,
                type: type,
                payReceiver: payReceiver,
                value: value,
                currency: currency,

                accountID: 0,
                name: null,
                lname: null,
                mname: null,
                td: null,
                nd: null,
                issuedBy: null,
                expiration: null,
                email: null,
                mobile: null,
                pep: null,

                office: null,
                nOffice: null,

                bank: null,
                nBank: null,
                wallet: null,
                tc: null,
                nc: null,
                cbu: null,
                cpf: null,
                nab: null,

                address: null,
                district: null,
                zipcode: null,
                city: null,
                state: null,

                rate: 0,
                convert: 0,
                cConvert: null,

                payment: 3,
                pay_method: 'EFECTIVO',

                voucher: null,
                payer: payer,
                payer_code: null,
                cash: 0
            }
            this.$validator.reset();
        }
    }
}
</script>

<style scoped>
.loading-indicator {
    font-weight: bold;
    font-size: 1.5rem;
    text-align: center;
}

.validation-success,
.validation-failure,
.validation-pending {
    position: absolute;
    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, .8);
    text-align: center;
    font-weight: bold;
    font-size: 1.4rem;
    padding: 10px;
    border-radius: 12px;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
}

.validation-success {
    color: #28a745;
}

.validation-pending {
    color: #ff7900;
}

.validation-failure {
    color: #dd1717;
}

.validation-success img,
.validation-failure img,
.validation-pending img {
    width: 100%;
    height: 132px;
    padding-bottom: 12px;
}
</style>
